export enum TaskStatus {
  NEW = 'new',
  COMPLETE = 'complete'
}
